import React, { forwardRef } from "react";
import { Box, BoxProps, Stack, StackProps } from "@chakra-ui/react";

export type GlassyStackProps = StackProps & {
  glow?: boolean;
  backplatePadding?: number; // px
  containerProps?: BoxProps;
  fullWidth?: boolean; // NEW
};

const GlassyStack = forwardRef<HTMLDivElement, GlassyStackProps>(
  (
    {
      glow = true,
      backplatePadding = 6,
      containerProps,
      rounded = "2xl",
      p = 4,
      spacing = 3,
      fullWidth,
      ...stackProps
    },
    ref
  ) => {
    return (
      <Box
        position="relative"
        display="inline-block"
        w={fullWidth ? "100%" : "fit-content"}
        sx={{ isolation: "isolate" }}
        {...containerProps}
      >
        {glow && (
          <Box
            aria-hidden
            position="absolute"
            inset={`-${backplatePadding}px`}
            rounded={rounded as any}
            bgGradient="linear(90deg, rgba(128,90,213,.35), rgba(236,72,153,.28))"
            _dark={{ bgGradient: "linear(90deg, rgba(168,132,255,.28), rgba(59,130,246,.22))" }}
            filter="blur(14px)"
            opacity={0.85}
            pointerEvents="none"
            zIndex={0}
          />
        )}

        <Stack
          ref={ref}
          w={fullWidth ? "100%" : undefined}
          direction="column"
          spacing={spacing}
          p={p}
          rounded={rounded}
          bg="blackAlpha.300"
          _dark={{ bg: "blackAlpha.700", borderColor: "whiteAlpha.200" }}
          border="1px solid"
          borderColor="blackAlpha.200"
        //   _dark={{  }}
          boxShadow="lg"
          backdropFilter="saturate(150%) blur(12px)"
          zIndex={1}
          {...stackProps}
        />
      </Box>
    );
  }
);

GlassyStack.displayName = "GlassyStack";
export default GlassyStack;
